// HitFit's own package catalog data — see common/utils/packageCatalog.js for what these fields
// mean and how they're used. Kept in sync with the HitFit Admin App's package setup (names,
// prices, session counts, member counts).
export const PACKAGE_CATALOG = [
  {
    key: "trial",
    name: "Besplatna proba",
    people: 1,
    sessionsPerPerson: [1],
    price: 0,
    matchServiceQty: null,
    isTrial: true,
    featured: false,
  },
  {
    key: "single",
    name: "Pojedinačni trening",
    people: 1,
    sessionsPerPerson: [1],
    price: 1200,
    matchServiceQty: 1,
    featured: false,
  },
  {
    key: "p1-8",
    name: "1 Vežbač · 8 termina",
    people: 1,
    sessionsPerPerson: [8],
    price: 6000,
    matchServiceQty: 8,
    featured: false,
  },
  {
    key: "p1-12",
    name: "1 Vežbač · 12 termina",
    people: 1,
    sessionsPerPerson: [12],
    price: 7500,
    matchServiceQty: 12,
    featured: true,
  },
  {
    key: "p2-8-8",
    name: "2 Vežbača · 8 + 8",
    people: 2,
    sessionsPerPerson: [8, 8],
    price: 11000,
    matchServiceQty: 8,
    featured: false,
  },
  {
    key: "p2-12-8",
    name: "2 Vežbača · 12 + 8",
    people: 2,
    sessionsPerPerson: [12, 8],
    price: 12000,
    matchServiceQty: 12,
    featured: false,
  },
  {
    key: "p2-12-12",
    name: "2 Vežbača · 12 + 12",
    people: 2,
    sessionsPerPerson: [12, 12],
    price: 12500,
    matchServiceQty: 12,
    featured: false,
  },
  {
    key: "p3-8-8-8",
    name: "3 Vežbača · 8 svaki",
    people: 3,
    sessionsPerPerson: [8, 8, 8],
    price: 16000,
    matchServiceQty: 8,
    featured: false,
  },
  {
    key: "p3-12-12-12",
    name: "3 Vežbača · 12 svaki",
    people: 3,
    sessionsPerPerson: [12, 12, 12],
    price: 18000,
    matchServiceQty: 12,
    featured: false,
  },
];
